// extracted by mini-css-extract-plugin
export default {"signupBlock":"signupBlock-LiZQI","signupBlockContainer":"signupBlockContainer-pTMN7","bglayer":"bglayer-mYeDh","signupBlockMobile":"signupBlockMobile-o8Q56"};